import {SITE_URL, buildUrl, ogLanguage} from './language';
import {SOCIALS} from '../data/socials';

// schema.org markup (JSON-LD) for search engines

export const person = (t) => ({
  '@type': 'Person',
  '@id': `${SITE_URL}/#person`,
  name: t('home.personName'),
  url: SITE_URL,
  jobTitle: t('home.jobTitle'),
  address: {'@type': 'PostalAddress', addressLocality: t('home.city'), addressCountry: 'KZ'},
  sameAs: Object.values(SOCIALS),
});

export const homeJsonLd = (lang, t) => ({
  '@context': 'https://schema.org',
  '@graph': [
    person(t),
    {
      '@type': 'WebSite',
      '@id': `${SITE_URL}/#website`,
      name: 'chernykh.tech',
      url: buildUrl(lang, '/'),
      inLanguage: lang,
      publisher: {'@id': `${SITE_URL}/#person`},
    },
  ],
});

export const appJsonLd = (lang, t, app) => ({
  '@context': 'https://schema.org',
  '@type': 'MobileApplication',
  name: t(`apps.${app.id}.name`),
  description: t(`appPages.${app.id}.description`),
  url: buildUrl(lang, app.page),
  image: `${SITE_URL}${app.ogImage}-${ogLanguage(lang)}.png`,
  inLanguage: lang,
  operatingSystem: 'Android, iOS',
  applicationCategory: 'EducationalApplication',
  sameAs: [app.appStore, app.googlePlay],
  author: person(t),
  offers: {'@type': 'Offer', price: '0', priceCurrency: 'USD'},
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: app.rating,
    ratingCount: app.ratingsTotal,
    bestRating: '5',
  },
});
